import React, { cloneElement, useState } from "react";

import { useSwipeable } from "react-swipeable";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { blue } from "../../../utils/colors";

const CarouselDiv = styled.div`
    padding: 20px 0;

    ${({ theme }) => theme.breakpoints.upTo.small.css`
        display: block;
        width: 100%;
        padding: 0;
        margin: 0 auto;
        overflow: hidden;
    `}
`;

const CarouselInnerDiv = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    column-gap: 40px;
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        display: block;
        justify-content: center;
        white-space: nowrap;
        transition: transform 0.3s;
    `}
`;

const CarouselButtonRow = styled.div`
    display: none;
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        display: flex;
        justify-content: center;
        margin: 20px;
    `}
`;

const CarouselButton = styled.div`
    width: 15px;
    height: 15px;
    margin: 3px;
    border-color: ${blue};
    border-style: solid;
    border-radius: 50%;
`;

const Active = css`
    background-color: ${blue};
`;

const Carousel = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const theme = useTheme();

    const Transform = css`
        ${theme.breakpoints.upTo.small.css`
            transform: translateX(-${activeIndex * 100}%);
        `}
    `;

    const isSmall = [
        theme.breakpoints.from.small.useMatches(),
        theme.breakpoints.upTo.small.useMatches(),
    ].every(Boolean);

    const itemsCount = Math.ceil(
        React.Children.count(children) / (isSmall ? 2 : 1)
    );
    const carouselButtonItems = new Array(itemsCount).fill(0).map((_, i) => i);
    const updateIndex = (newIndex) => {
        if (newIndex < 0) {
            newIndex = 0;
        } else if (newIndex >= itemsCount) {
            newIndex = itemsCount - 1;
        }
        setActiveIndex(newIndex);
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => updateIndex(activeIndex + 1),
        onSwipedRight: () => updateIndex(activeIndex - 1),
    });

    const getSpacing = css`
        ${React.Children.count(children) < 4
            ? "justify-content: flex-start; column-gap: 165px;"
            : " justify-content: space-between"};
    `;

    return (
        <CarouselDiv {...handlers}>
            <CarouselInnerDiv
                css={css`
                    ${Transform} ${getSpacing}
                `}
            >
                {children.map((item) => {
                    return cloneElement(item);
                })}
            </CarouselInnerDiv>
            <CarouselButtonRow>
                {carouselButtonItems.map((item, index) => {
                    return (
                        <CarouselButton
                            key={index}
                            css={css`
                                ${index === activeIndex ? Active : ""}
                            `}
                            onClick={() => {
                                updateIndex(index);
                            }}
                        />
                    );
                })}
            </CarouselButtonRow>
        </CarouselDiv>
    );
};

Carousel.Item = styled.div`
    padding: 5px;
    ${({ theme }) => theme.breakpoints.upTo.small.css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 50%;
    `}
    ${({ theme }) => theme.breakpoints.upTo.extraSmall.css`
        width: 100%;
    `}
`;
Carousel.Item.displayName = "Carousel.Item";

export default Carousel;
